import React from "react";
import { useParams, Link } from "react-router-dom";
import useFetch from "../../components/hooks/useFetch";
import Axios from "axios";
import { saveAs } from 'file-saver';
import { IoMdArrowBack, IoMdDownload } from "react-icons/io";
import Navbar from "./Navbar";
import Footer from "./Footer";

export default function ReviewDetails() {
  const { id } = useParams();
  const token = localStorage.getItem("token");
  const { loading, error, data } = useFetch(`${process.env.REACT_APP_API_URL}/archives/${id}`, token);

  const download = (fileUrl, fileName) => {
    Axios({
      url: fileUrl,
      method: "GET",
      responseType: "blob",
      headers: {
        'Authorization': `Bearer ${token}`
      },
    }).then((res) => {
      saveAs(res.data, fileName);
    }).catch(error => {
      console.error("Download error:", error);
      // Handle download error (e.g., show notification to user)
    });
  };

  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error :(</p>;

  const fileUrl = data?.file && data.file.length > 0 ? `${process.env.REACT_APP_API_URL}${data.file[0].url}` : "";
  const fileName = data?.file && data.file.length > 0 ? data.file[0].name : "Downloaded.pdf";
  const isImage = /\.(jpg|jpeg|png|gif|bmp|svg)$/.test(fileUrl);

  return (
    <>
      <Navbar />
      <div className='justify-between px-4 mx-auto lg:max-w-7xl md:items-center md:flex md:px-8'>
        <div className="container mx-auto px-4 py-5">
          <Link to='/listArchive' className="text-blue-600 hover:text-blue-800 flex items-center mb-4">
            <IoMdArrowBack className="mr-1" /> Back to Archives
          </Link>

          {error && <p className="text-red-500">Error loading details: {error.message}</p>}

          {!loading && data && (
            <div className="bg-white shadow-lg rounded-lg p-5 md:p-8">
              <h2 className="text-2xl font-semibold mb-2">{data.title}</h2>
              <p className="text-gray-700 mb-4">{data.description}</p>

              {fileUrl && (
                isImage ? (
                  <img src={fileUrl} alt="File" style={{ maxWidth: '50%', height: 'auto', marginBottom: '20px' }} />
                ) : (
                  <a href={fileUrl} target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-800">
                    Open PDF
                  </a>
                )
              )}

              <div className="flex items-center justify-between">
                <span className="text-gray-500">Published: {data.published_at}</span>
                <button
                  className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded inline-flex items-center"
                  onClick={() => download(fileUrl, fileName)}
                >
                  <IoMdDownload className="mr-2" /> Download {fileName}
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
      <Footer />
    </>
  );
}
